import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import RichTooltip from 'LuxKit/RichTooltip'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyEnabledDecision } from 'lib/optimizely/optimizelyUtils'

const LUX_EXCLUSIVE_TOOLTIP_SHOWN_KEY = 'le_lux_exclusive_tooltip_shown'

interface Props {
  children: React.ReactNode
  autoOpenOnce?: boolean
}

function LtleTooltipWrapper({ children, autoOpenOnce = false }: Props) {
  const intl = useIntl()
  const experimentVariation = useOptimizelyExperiment(OptimizelyExperiments.croLtleToolkit)
  const enabled = getOptimizelyEnabledDecision(experimentVariation)

  const [shouldAutoOpen] = useState(() => {
    if (!autoOpenOnce || !enabled) return false
    if (typeof window === 'undefined') return false
    try {
      if (localStorage.getItem(LUX_EXCLUSIVE_TOOLTIP_SHOWN_KEY) === 'true') return false
      localStorage.setItem(LUX_EXCLUSIVE_TOOLTIP_SHOWN_KEY, 'true')
    } catch { return false }
    return true
  })

  if (!enabled) return <>{children}</>

  const tooltipText = intl.formatMessage({
    id: 'mhV3L8Rt6N',
    defaultMessage: 'Limited-time offers you won\'t find anywhere else, handpicked and curated by our team with our best price guarantee!',
    description: 'Tooltip describing Limited Time Lux Exclusive offers',
  })

  return (
    <RichTooltip
      variant="dark"
      description={tooltipText}
      placement="top-start"
      showOnHover
      portaled
      forcePointerEvents
      defaultOpen={shouldAutoOpen}
      dismissible={shouldAutoOpen}
      closeOnOutsideClick={shouldAutoOpen}
    >
      {children}
    </RichTooltip>
  )
}

export default LtleTooltipWrapper
